exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shareBlock{padding:30px}.shareBlock a{text-decoration:none;display:block;width:45%;padding:5px;background:#004646;font-weight:700;color:#fff;border-radius:10px;margin:5px;float:left;cursor:pointer;opacity:.8}.shareBlock a:hover{text-decoration:none;opacity:1}.shareBlock img{max-width:32px;max-height:32px;margin-right:10px}", ""]);

// exports
